export enum EAction {
  SET_DOM_CONTAINER,
  SET_MARKING_INSTANCE
}
